import React from "react";
import { useSearchParams } from "react-router-dom";
import { SmsInbox } from "@/components/helm/SmsInbox";
import { CallHistory } from "@/components/helm/CallHistory";
import { BusinessDialer } from "@/components/helm/BusinessDialer";

export default function HelmMessages() {
  const [params] = useSearchParams();
  return (
    <div className="p-6 sm:p-10 max-w-5xl mx-auto" data-testid="helm-messages-page">
      <h1 className="font-display text-3xl text-[#0B192C] mb-1">Messages</h1>
      <p className="text-sm text-[#6B7280] mb-5">
        Texts to and from your SBA business number. New-reply alerts appear only while Helm is open in a browser tab — there are no phone, email or push notifications.
      </p>
      <BusinessDialer />
      <SmsInbox full initialThread={params.get("thread") || ""} />
      <CallHistory />
    </div>
  );
}
